export default __webpack_public_path__ + "static/media/photo8.4da83a31.jpg";